"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbooksGridSortProvider = exports.WorkbooksDefaultSortField = exports.WorkbooksDefaultDirections = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var globalTypes_1 = require("../../../../gen-src/queries/globalTypes");
exports.WorkbooksDefaultDirections = (_a = {},
    _a[globalTypes_1.WorkbookOrderField.NAME] = globalTypes_1.OrderDirection.ASC,
    _a[globalTypes_1.WorkbookOrderField.SHEETS_COUNT] = globalTypes_1.OrderDirection.DESC,
    _a[globalTypes_1.WorkbookOrderField.PROJECT_NAME] = globalTypes_1.OrderDirection.ASC,
    _a[globalTypes_1.WorkbookOrderField.CONTAINER_NAME] = globalTypes_1.OrderDirection.ASC,
    _a);
exports.WorkbooksDefaultSortField = globalTypes_1.WorkbookOrderField.NAME;
function WorkbooksGridSortProvider(props) {
    return (React.createElement(data_catalog_shared_1.UrlSortProvider, { validOrderFieldsWithDefaultDirections: exports.WorkbooksDefaultDirections, defaultField: exports.WorkbooksDefaultSortField }, props.children));
}
exports.WorkbooksGridSortProvider = WorkbooksGridSortProvider;
//# sourceMappingURL=WorkbooksGridSortProvider.js.map